import type { CSSProperties } from "react";

/**
 * Grille des raccourcis, remplie colonne par colonne comme sur la maquette
 * (4 à gauche, 4 à droite) — même ordre dans le bloc et dans la modale.
 */
export const SHORTCUT_GRID_CLASS =
  "grid list-none grid-cols-1 md:grid-flow-col md:grid-cols-2 md:[grid-template-rows:repeat(var(--rows),auto)]";

export function shortcutGridStyle(count: number): CSSProperties {
  return { "--rows": Math.max(1, Math.ceil(count / 2)) } as CSSProperties;
}
